import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MensagensService} from 'max-ng-lib';
import {GenericRoteirizadorService} from 'src/app/core/services';
import {LinkBaseConhecimento} from '../models/link-base-conhecimento';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class LinksBaseConhecimentoService extends GenericRoteirizadorService {
  constructor(
    private _mensagensService: MensagensService,
    private _httpClient: HttpClient
  ) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/link';
  }

  listarPorSolucao() {
    return this.get<LinkBaseConhecimento[]>('/listar');
  }


  async salvarSessionStorage() {
    const links = await this.listarPorSolucao().toPromise();
    sessionStorage.setItem('links', JSON.stringify(links));
  }

  obtenhaSessionStorage(): LinkBaseConhecimento[] {
    try {
      return JSON.parse(sessionStorage.getItem('links'));
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  getLinkBaseConhecimento(solucao: string): LinkBaseConhecimento {
    const links = this.obtenhaSessionStorage();
    return links.find((link) => link.id === solucao);
  }

  inativarLink(id: string): Observable<void> {
    return this.post<void>(`/inativar?id=${id}`);
  }
}
